import React, { useState, useEffect, useRef } from 'react';
import { MdDelete } from "react-icons/md";

const ModalConfirmDelete: React.FC<{ apiKeyId: string, onDelete: (id: string) => void }> = ({ apiKeyId, onDelete }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const trigger = useRef<any>(null);
  const modal = useRef<any>(null);

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }: MouseEvent) => {
      if (!modal.current) return;
      if (
        !modalOpen ||
        modal.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setModalOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }: KeyboardEvent) => {
      if (!modalOpen || keyCode !== 27) return;
      setModalOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  const handleConfirmDelete = () => {
    onDelete(apiKeyId);
    setModalOpen(false);
  };

  return (
    <div>
      <div
        ref={trigger}
        onClick={() => setModalOpen(!modalOpen)}
        className="inline-block cursor-pointer"
      >
        <MdDelete className="text-[#db1f48] text-[20px]" />
      </div>
      <div
        className={`fixed left-0 top-0 z-999999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5 ${
          modalOpen ? 'block' : 'hidden'
        }`}
      >
        <div
          ref={modal}
          onFocus={() => setModalOpen(true)}
          onBlur={() => setModalOpen(false)}
          className="md:px-17.5 w-full max-w-142.5 rounded-lg bg-white px-8 py-12 text-center dark:bg-boxdark md:py-15"
        >
          <h3 className="pb-2 text-xl font-bold text-black dark:text-white sm:text-2xl text-[#db1f48]">
            Confirm deletion of API key
          </h3>
          <span className="mx-auto mb-6 inline-block h-1 w-22.5 rounded bg-[#db1f48]"></span>
          <p className="mb-10">
            Removing API key is permanent, and can not be undone.
          </p>
          <div className="-mx-3 flex flex-wrap gap-y-4">
            <div className="2xsm:w-1/2 w-full px-3">
              <button
                onClick={() => setModalOpen(false)}
                className="block w-full rounded border border-stroke bg-gray p-3 text-center font-medium text-black transition hover:border-meta-1 hover:bg-meta-1 hover:text-white dark:border-strokedark dark:bg-meta-4 dark:text-white dark:hover:border-meta-1 dark:hover:bg-meta-1"
              >
                Cancel
              </button>
            </div>
            <div className="2xsm:w-1/2 w-full px-3">
              <button
                onClick={handleConfirmDelete}
                className="block w-full rounded border border-[#db1f48] bg-[#db1f48] p-3 text-center font-medium text-white transition hover:bg-opacity-90"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmDelete;
